'use strict';

import intlTelInput from 'intl-tel-input';

const input = document.querySelector("#contactForm-phone");
if (input) {
    intlTelInput(input, {
        initialCountry: "it",
        separateDialCode: true,
        loadUtils: () => import("intl-tel-input/build/js/utils.js"),
    });

    input.addEventListener("input", function () {
        this.value = this.value.replace(/[^\d+]/g, "");

        if (this.value.length > 15) {
            this.value = this.value.slice(0, 15);
        }
    });
}

$('#contactForm-departureDate').on("focusout", function (){
    
    const departureDateField = $('#contactForm-departureDate');
    const departureDate = departureDateField.length ? departureDateField.val() : '';
    const today = new Date();
    const todayFormatted = today.toISOString().split('T')[0];

    const parentEl = departureDateField.closest('.form-group');
    const invalidFeedback = parentEl.find('.invalid-feedback');

    departureDateField.removeClass('is-invalid');
    parentEl.removeClass('is-invalid');
    invalidFeedback.removeClass('d-block');

    if (departureDate && departureDate < todayFormatted) {
        departureDateField.addClass('is-invalid');
        parentEl.addClass('is-invalid');

        const errorMsg = departureDateField[0].validationMessage;
        invalidFeedback.html(errorMsg).addClass('d-block');
    }
});

$('#contactUsForm-myQuestion').on("change", function () {
    const $contactUsForm = $('.contact-us');
    if ($('#contactUsForm-myQuestion option:selected').val() === 'Preventivo') {
        // Change controller endpoint to open an opportunity
        $contactUsForm.attr('action', $contactUsForm.data('opportunity-action'));

        let controllers = $contactUsForm.data('opportunity-action').match(/[^/]+$/);
        if (controllers && controllers.length) {
            let submitInput = $contactUsForm.find('input[name=idsubmit]');

            if (submitInput) {
                submitInput.attr('data-id', controllers[0]);
            }
        }

        // Show the additional fields and set it as mandatory fields
        $(".preventivo-subform input").attr('required', 'required');
        $(".preventivo-subform").removeClass('d-none').addClass('d-block');
        $(".privacy-altro").removeClass('d-none');
        $(".privacy-preventivo").addClass('d-none').find('input[type=radio]').prop('disabled', true).prop('required', false).prop('checked', false);        
        
    } else {
        // Change controller endpoint to open a case
        $contactUsForm.attr('action', $contactUsForm.data('case-action'));

        let controllers = $contactUsForm.data('case-action').match(/[^/]+$/);
        if (controllers && controllers.length) {
            let submitInput = $contactUsForm.find('input[name=idsubmit]');

            if (submitInput) {
                submitInput.attr('data-id', controllers[0]);
            }
        }

        // Hide for every other option
        $(".preventivo-subform input").removeAttr('required');
        $(".preventivo-subform").removeClass('d-block').addClass('d-none');        
        $(".privacy-preventivo").removeClass('d-none').find('input[type=radio]').prop('disabled', false).prop('required', true);        
        $(".privacy-altro").addClass('d-none');
       
    }           
});

const form = $('#CaseCreationForm');

if (form.length > 0) {
    form[0].reset();
}

form.on('submit', function () {      

    // Send additional note only if the form is submitted from the booking funnel
    if ($('#sendAdditionalNote').length) {
        const MAX_LENGTH = 4;
        // Append session variables
        const sessionKeys = [
            'NOME TOUR',
            'DATA PARTENZA',
            'FORMULA',
            'CITTA DI PARTENZA',
            'CAMERE TOTALI',
            'OSPITI_',
            'TIPO_',
            'PICK-UP',
            'SCELTA VOLO',
            'VOLO',
            'FACOLTATIVE',
            'ASSICURAZIONE FACOLTATIVA',
            'SCONTI'
        ]
        const dynamicKeysSubArray = sessionKeys.filter(sessionKey => sessionKey.indexOf('_') !== -1);
        let dynamicPropertiesFilled = false;
        let additionalNote = '';
        sessionKeys.forEach(sessionKey => {
            let sessionvalue = localStorage.getItem(sessionKey);
            if (sessionvalue) {
                // Check for single value
                // Eg. NOME TOUR
                additionalNote += sessionKey + ':' + sessionvalue + ' ;';
            } else if (dynamicKeysSubArray.indexOf(sessionKey) !== -1 && !dynamicPropertiesFilled) {
                // Check for multiple values and preserve order
                // Eg. TIPO_1, OSPITI_1
                // Ospiti e tipo
                for (let outIndex = 0; outIndex < MAX_LENGTH; outIndex++) {
                    let camera = outIndex + 1; //Normalize room index
                    for (let innerIndex = 0; innerIndex < dynamicKeysSubArray.length; innerIndex++) {
                        const dynamicKey = dynamicKeysSubArray[innerIndex] + outIndex; //Tipo_0 || Ospiti_0
                        sessionvalue = localStorage.getItem(dynamicKey)
                        if (sessionvalue) {
                            if (innerIndex === 0) {
                                additionalNote += 'Camera: ' + camera + ' ';
                            }
                            const strippedKey = dynamicKey.split('_')[0];
                            additionalNote += strippedKey + ':' + sessionvalue + ' ;';
                        }
                    }
                    dynamicPropertiesFilled = true;
                }
            }
        });
        $('#additionalNote').val(additionalNote);
    }

    let fromPageUrl = localStorage.getItem('URL');
    let fromPageInput = $('#fromPage');
    fromPageInput.val(fromPageUrl || fromPageInput.data('default'));

    if ($('#sendAdditionalNoteUrl').length) {
        let additionalNote = ' URL:' + localStorage.getItem('URL');
        $('#additionalNote').val(additionalNote);
    } else {
        if (localStorage.getItem('URL')) {
            localStorage.removeItem('URL');
        }
    }

    const phoneInputField = document.querySelector('#contactForm-phone');
    const iti = window.intlTelInputGlobals.getInstance(phoneInputField);

    if (iti) {
        phoneInputField.value = iti.getNumber();
    }
});

$('#privacyOptIn').on('click', function () {
    $('.js-accept-privacy').addClass('hidden');
});

if ($('#successfulSubmit').length) {
    localStorage.clear();
}